import Service from './service';

const INITIAL_LOADING_READY_EVENT = 'inspectpro:initial-loading-ready';

export default class Loading {

    public isshow: boolean = false;
    public opts: any = {};

    constructor(private service: Service) { }

    public async show(mopts: any = {}) {
        this.isshow = true;
        this.opts = {};
        for (let key in mopts)
            this.opts[key] = mopts[key];
        await this.service.render();
    }

    public async hide() {
        this.isshow = false;
        window.dispatchEvent(new CustomEvent(INITIAL_LOADING_READY_EVENT));
        await this.service.render();
    }

}
